



































































































import { Component, Vue } from 'vue-property-decorator'
@Component
export default class ForgotPassword extends Vue {
    loading = false
    formRules = {
        pin: [
            (v: string) => !!v || 'Pin is required',
            (v: string) => {
                if (v) {
                    return (v.length === 6) || 'Field must be 6 characters'
                } else {
                    return true
                }
            },
            (v: string) => {
                if (v) {
                    const pattern = /^[0-9]+$/
                    return pattern.test(v) || 'Only numbers is valid'
                } else {
                    return true
                }
            }

        ],
        email: [
            (v: string) => !!v || 'Email is required',
            (v: string) => {
                if (v) {
                    return (v.length <= 64) || 'Field must be less than 50 characters'
                } else {
                    return true
                }
            },
            (v: string) => {
                if (v) {
                    return (v.length >= 5) || 'Field must at least 5 characters'
                } else {
                    return true
                }
            },
            (v: string) => {
                if (v) {
                    const pattern = /^\w+([.-]?\w+)*(\+\w+)?@\w+([.-]?\w+)*(\.\w{2,})+$/
                    return pattern.test(v) || 'Email entered is not valid'
                } else {
                    return true
                }
            }
        ],
        password: [
            (v: string) => !!v || 'Password is required',
            (v: string) => (v && v.length <= 128) || 'Field must be less than 128 characters',
            (v: string) => (v && v.length >= 8) || 'Field must at least 8 characters'
        ]
    }

    formData = {
        email: null,
        password: null,
        confirmPassword: null,
        pin: null
    }

    emailSendPin = false
    formValid = false

    async sendPin () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return
        this.loading = true
        this.$store.dispatch('sendResetPasswordPin', this.formData.email)
            .then(resp => {
                this.loading = false
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Send Successfully!')
                    this.emailSendPin = true
                }
            })
    }

    async resetPassword () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return
        this.loading = true
        this.$store.dispatch('resetPasswordPin', this.formData)
            .then(resp => {
                this.loading = false
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$router.push({ name: 'Login' })
                }
            })
    }
}
